export enum LookupFieldFilterTypeEnum {
  PARENT_OBJECT = 'PARENT_OBJECT',
  RELATED_OBJECT = 'RELATED_OBJECT',
  HQL = 'HQL',
}
